import React, { useState } from 'react'
import './LockerManagement.css';
import CloseIcon1 from '../../svgIcons/CloseIcon1';
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch';
import toast from 'react-hot-toast';

interface LockerManageMentProps {
    locationId: string;
    locationName: string;
    setShowModal: (isOpen: boolean) => void;
}

const unitLockerList = [
    { id: 1, unitName: "Unit A101", lockerNumber: 12, status: true },
    { id: 2, unitName: "Unit A102", lockerNumber: 14, status: true },
    { id: 3, unitName: "Unit A103", lockerNumber: null, status: false },
    { id: 4, unitName: "Unit A104", lockerNumber: 9, status: true },
    { id: 5, unitName: "Unit A105", lockerNumber: null, status: false },
    { id: 6, unitName: "Unit B201", lockerNumber: 5, status: true },
    { id: 7, unitName: "Unit B202", lockerNumber: 8, status: true },
    { id: 8, unitName: "Unit B203", lockerNumber: null, status: false },
    { id: 9, unitName: "Unit B204", lockerNumber: 3, status: true },
    { id: 10, unitName: "Unit B205", lockerNumber: null, status: false },
    { id: 11, unitName: "Unit C301", lockerNumber: 6, status: true },
    { id: 12, unitName: "Unit C302", lockerNumber: null, status: false },
    { id: 13, unitName: "Unit C303", lockerNumber: 2, status: true },
    { id: 14, unitName: "Unit C304", lockerNumber: 11, status: true },
    { id: 15, unitName: "Unit C305", lockerNumber: null, status: false },
    { id: 16, unitName: "Unit D401", lockerNumber: 7, status: true },
    { id: 17, unitName: "Unit D402", lockerNumber: null, status: false },
    { id: 18, unitName: "Unit D403", lockerNumber: 13, status: true },
    { id: 19, unitName: "Unit D404", lockerNumber: null, status: false },
    { id: 20, unitName: "Unit D405", lockerNumber: 10, status: true },
];

const LockerManageMent = ({ locationId, locationName, setShowModal }: LockerManageMentProps) => {

    const [unitsListing, setUnitsListing] = useState(unitLockerList)
    const [loadingIds, setLoadingIds] = useState<number[]>([])


    const onToggleSwitch = (unitId: number) => {
        const id = Number(unitId);
        setLoadingIds((prev) => [...prev, id]);
        setTimeout(() => {
            setUnitsListing((prevUnits) => {
                const updatedUnits = prevUnits.map((unit) =>
                    unit.id === id ? { ...unit, status: !unit.status } : unit
                );
                // Show toast after updating status
                const updatedUnit = updatedUnits.find((unit) => unit.id === id);
                if (updatedUnit) {
                    toast.success(
                        `Unit ${updatedUnit.unitName} locker is now ${updatedUnit.status ? 'Open' : 'Closed'}`
                    );
                }
                return updatedUnits;
            });
            setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));
        }, 2000);
    }

    return (
        <div className="modal-container locker-management-modal">
            <div className="modal-header">
                <h3>{locationName}</h3>
                <div className="close-icon" onClick={() => { setShowModal(false) }}>
                    <CloseIcon1 />
                </div>
            </div>
            <div className="modal-body-container">
                <table className="locker-table">
                    <thead>
                        <tr>
                            <th>Unit Name</th>
                            <th>Locker Number</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {unitsListing?.map((unit) => (
                            <tr key={unit.id} className={unit.status ? 'active-row' : 'inactive-row'}>
                                <td>{unit.unitName}</td>
                                <td>{unit.lockerNumber !== null ? unit.lockerNumber : <span className="no-locker">—</span>}</td>
                                <td>
                                    {unit?.lockerNumber !== null ? (
                                        <ToggleSwitch
                                            checked={unit?.status}
                                            disabled={false}
                                            loading={loadingIds.includes(unit.id)}
                                            onChange={() => onToggleSwitch(unit.id)}
                                        />
                                    ) : (
                                        '-'
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default LockerManageMent
